import type { ContentBlock } from "@/types/content-blocks";

type PermissionData = Extract<ContentBlock, { type: "permission" }>;

interface Props {
  block: PermissionData;
  onApprove: (toolId: string) => void;
  onDeny: (toolId: string) => void;
  onAlwaysAllow: (toolName: string) => void;
}

export function PermissionBlock({ block, onApprove, onDeny, onAlwaysAllow }: Props) {
  if (block.status !== "pending") {
    return (
      <div className="my-1 rounded-md border border-white/[0.06] bg-[#151518] px-3 py-2 flex items-center gap-2">
        <span className="text-[12px] font-mono text-zinc-400">{block.toolName}</span>
        <span className={`text-[11px] ${block.status === "approved" ? "text-emerald-400" : "text-red-400"}`}>
          {block.status === "approved" ? "Allowed" : "Denied"}
        </span>
      </div>
    );
  }

  return (
    <div className="my-1 rounded-md border border-amber-500/30 bg-amber-500/[0.04] overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-white/[0.04]">
        <span className="text-[12px] font-mono text-amber-300">{block.toolName}</span>
        <span className="text-[11px] text-zinc-500">wants to run</span>
      </div>
      <div className="flex gap-2 px-3 py-2">
        <button
          onClick={() => onApprove(block.toolId)}
          className="px-3 py-1 text-[11px] bg-emerald-500/10 text-emerald-400 border border-emerald-500/30 rounded cursor-pointer hover:bg-emerald-500/20 transition-colors"
        >
          Allow
        </button>
        <button
          onClick={() => onDeny(block.toolId)}
          className="px-3 py-1 text-[11px] bg-red-500/10 text-red-400 border border-red-500/30 rounded cursor-pointer hover:bg-red-500/20 transition-colors"
        >
          Deny
        </button>
        <button
          onClick={() => onAlwaysAllow(block.toolName)}
          className="px-3 py-1 text-[11px] text-zinc-500 border border-white/[0.06] rounded cursor-pointer hover:bg-white/[0.04] transition-colors"
        >
          Always allow {block.toolName}
        </button>
      </div>
    </div>
  );
}
